// extracted by mini-css-extract-plugin
module.exports = {"main-component":"logoutArrow_main-component__3Ik6Y"};